module.exports = __webpack_public_path__ + "img/right_click.6b4cc3a1.png";